import React, { useContext, useState } from 'react'
import { Trans, t } from '@lingui/macro'

import { DashboardItemTypes } from 'front-end/src/graphql/private/PrivateSchemaTypes'
import IconMap from 'front-end/src/components/common/icon/IconMap'

import { ItemsPaneHeader } from './components/ItemsPaneHeader'
import { EmptyList } from './components/EmptyList'
import { AddItemModal } from '../modals/AddItemModal'
import Controls from './components/Controls'
import { GetDashboardQuery } from '../manage/ManageDashboardPage.codegen'
import { useAddDashboardItemMutation } from '../modals/AddItemModal.codegen'

import './ItemsPane.less'
import { ManageDashboardPageContext } from 'front-end/src/pages/dashboards-page/manage/ManageDashboardPage'
interface IProps {
  dashboardId: number
  // TODO write the GQL query with a fragment and use the fragment type here
  items: NonNullable<
    NonNullable<
      NonNullable<GetDashboardQuery['admin']>['dashboard']
    >['pathways']
  >
}

export const PathwaysPane = ({ items, dashboardId }: IProps) => {
  const { refetch } = useContext(ManageDashboardPageContext)
  const [showModal, setShowModal] = useState(false)
  const [addDashboardItem] = useAddDashboardItemMutation()

  return (
    <div className="ItemsPane">
      <ItemsPaneHeader
        title={<Trans>Pathways</Trans>}
        icon={<IconMap mr="5px" />}
        showButton={!!items.length}
        onAdd={() => setShowModal(true)}
      />

      {!items.length && (
        <EmptyList entityName={t`Pathways`} onAdd={() => setShowModal(true)} />
      )}

      {items.map((item) => (
        <div className="ItemsPane__item" key={item.id}>
          <div className="ItemsPane__item__left">
            <div>{item.title}</div>
            <Controls
              dashboardId={dashboardId}
              itemId={item.id}
              itemType={DashboardItemTypes.pathway}
              refetch={refetch}
            />
          </div>
        </div>
      ))}

      {showModal && (
        <AddItemModal
          title={t`Pathways`}
          entityType={DashboardItemTypes.pathway}
          itemIds={items.map((i) => i.id)}
          onSubmit={async (selectedIds, spreadItems) => {
            await addDashboardItem({
              variables: {
                dashboardId,
                itemIds: selectedIds,
                itemType: DashboardItemTypes.pathway,
                spreadItems
              }
            })
            await refetch()
          }}
          onHide={() => setShowModal(false)}
        />
      )}
    </div>
  )
}
